// Distinguished Chic — theme JS: mobile menu + cart Remove / Save for Later
document.addEventListener('DOMContentLoaded', function () {
  console.log('Distinguished Chic theme loaded');

  // Mobile hamburger menu
  var menuToggle = document.getElementById('dc-menu-toggle');
  var mobileNav = document.getElementById('dc-mobile-nav');
  var mobileNavClose = document.getElementById('dc-mobile-nav-close');
  var mobileNavBackdrop = document.getElementById('dc-mobile-nav-backdrop');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (mobileNavBackdrop) mobileNavBackdrop.classList.add('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (mobileNavBackdrop) mobileNavBackdrop.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavBackdrop) mobileNavBackdrop.addEventListener('click', closeMobileNav);
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMobileNav);
    });
  }

  // Cart: Remove / Save for Later
  var SAVE_KEY = 'dc_saved_items';

  function getSavedItems() {
    try {
      return JSON.parse(localStorage.getItem(SAVE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setSavedItems(items) {
    localStorage.setItem(SAVE_KEY, JSON.stringify(items));
  }

  function renderSavedItems() {
    var container = document.getElementById('dc-saved-for-later');
    if (!container) return;
    var items = getSavedItems();
    if (items.length === 0) {
      container.innerHTML = '';
      return;
    }
    var html = '<h2 class="dc-saved-for-later__title">Saved for Later</h2><div class="dc-saved-for-later__grid">';
    items.forEach(function (item, index) {
      html += '<div class="dc-saved-item" data-index="' + index + '">' +
        '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>' +
        '<div class="dc-saved-item__info">' +
        '<p class="dc-saved-item__title">' + item.title + '</p>' +
        '<p class="dc-saved-item__variant">' + item.variantTitle + '</p>' +
        '<p class="dc-saved-item__price">' + item.price + '</p>' +
        '<div class="dc-saved-item__actions">' +
        '<button type="button" class="dc-saved-item__move-btn" data-index="' + index + '">Move to Cart</button>' +
        '<button type="button" class="dc-saved-item__remove-btn" data-index="' + index + '">Remove</button>' +
        '</div></div></div>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('.dc-saved-item__move-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        var currentItems = getSavedItems();
        var item = currentItems[idx];
        if (!item) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.variantId, quantity: 1 })
        }).then(function (res) {
          if (res.ok) {
            currentItems.splice(idx, 1);
            setSavedItems(currentItems);
            window.location.reload();
          }
        });
      });
    });

    container.querySelectorAll('.dc-saved-item__remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        var currentItems = getSavedItems();
        currentItems.splice(idx, 1);
        setSavedItems(currentItems);
        renderSavedItems();
      });
    });
  }

  document.querySelectorAll('.dc-cart__remove-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function (res) {
        if (res.ok) window.location.reload();
      });
    });
  });

  document.querySelectorAll('.dc-cart__save-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var item = {
        variantId: parseInt(btn.getAttribute('data-variant-id'), 10),
        title: btn.getAttribute('data-title'),
        variantTitle: btn.getAttribute('data-variant-title'),
        price: btn.getAttribute('data-price'),
        image: btn.getAttribute('data-image'),
        url: btn.getAttribute('data-url')
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function (res) {
        if (res.ok) {
          var items = getSavedItems();
          items.push(item);
          setSavedItems(items);
          window.location.reload();
        }
      });
    });
  });

  renderSavedItems();
});
